import { Component } from '@angular/core';

@Component({
  selector: 'app-register-result-page',
  templateUrl: './register-result-page.component.html',
  styleUrls: ['./register-result-page.component.scss']
})
export class RegisterResultPageComponent {}
